module.exports = __webpack_public_path__ + "static/pi1-d2f6a1363b84beb62afc613fdbf6e06d.png";